export type LeadStatus = 'New' | 'Contacted' | 'Quoted' | 'Negotiating' | 'Won' | 'Lost';
export type Priority = 'high' | 'medium' | 'low';
export type LeadSource = 'WhatsApp' | 'Website' | 'Phone' | 'Email' | 'Referral' | 'Walk-in';

export interface Lead {
  id: string;
  name: string;
  email: string;
  phone: string;
  country: string;
  service: string;
  serviceIcon: string;
  budget: string;
  budgetNum: number;
  status: LeadStatus;
  source: LeadSource;
  sourceIcon: string;
  assignedTo: string;
  assignedAvatar: string;
  createdAt: string;
  updatedAt: string;
  notes: NoteEntry[];
  tags: string[];
  travelDate: string;
  pax: number;
}

export interface NoteEntry {
  id: string;
  author: string;
  authorAvatar: string;
  text: string;
  timestamp: string;
  type: 'note' | 'call' | 'email' | 'whatsapp' | 'status';
}

export interface Customer {
  id: string;
  name: string;
  email: string;
  phone: string;
  nationality: string;
  passportNo: string;
  passportExpiry: string;
  dob: string;
  address: string;
  avatar: string;
  totalBookings: number;
  totalSpent: string;
  lastBooking: string;
  joinedAt: string;
  tags: string[];
  bookings: CustomerBooking[];
  notes: NoteEntry[];
}

export interface CustomerBooking {
  id: string;
  service: string;
  serviceIcon: string;
  travelDate: string;
  returnDate: string;
  status: 'Confirmed' | 'Pending' | 'Cancelled' | 'Completed';
  amount: string;
  payStatus: 'Paid' | 'Partial' | 'Unpaid' | 'Refunded';
  pax: number;
  agent: string;
}

export interface Task {
  id: string;
  title: string;
  description: string;
  priority: Priority;
  status: 'pending' | 'in_progress' | 'done';
  dueDate: string;
  dueTime: string;
  assignedTo: string;
  assignedAvatar: string;
  linkedLead: string;
  linkedLeadName: string;
  category: 'follow_up' | 'documentation' | 'payment' | 'booking' | 'other';
  createdAt: string;
}

export const crmLeads: Lead[] = [];

export const crmCustomers: Customer[] = [];

export const crmTasks: Task[] = [];
